import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
  host: { '[class.loading-inline]': "size === 'inline'" },
  template: `<img src="assets/global-parts-plane-loading.webp" width="100" height="73" alt="Carregando...">`,
  styles: [`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 auto;
      width: 100px;
      max-width: 100%;
      vertical-align: middle;
      line-height: 0;
    }
    :host(.loading-inline) { width: 28px; }
    img {
      display: block;
      width: 100%;
      height: auto;
      object-fit: contain;
    }
  `]
})
export class LoadingIndicatorComponent {
  @Input() size: 'page' | 'inline' = 'page';
}
